/**
 * 檢查 Emoji 是否支援膚色切換
 */
export const canHaveSkinTone = (emoji) => {
  if (!emoji) return false;
  const char = typeof emoji === 'string' ? emoji : emoji.char;
  const category = emoji.category;

  // 1. 嚴格類別過濾：只有人物與手勢、活動類別通常支援膚色
  if (category) {
    const allowedCategories = ['gestures', 'activities'];
    if (!allowedCategories.includes(category)) return false;
  }

  const codePoint = char.codePointAt(0);
  
  // 排除雖然在這些類別但不支持膚色的物品
  const excluded = [
    0x1F5E3, 0x1F464, 0x1F465, 0x1F463, 0x1F3C6, 0x1F3C5, 0x1F3D0, 0x1F3C0, 0x1F3C8, 0x1F3C9, 
    0x1F3BE, 0x1F3B1, 0x1F3B3, 0x1F3CF, 0x1F3D1, 0x1F3D2, 0x1F3D3, 0x1F3F8, 0x1F94A, 0x1F94B, 
    0x1F945, 0x1F94F, 0x1F94E, 0x1F97A, 0x1F97B, 0x26BD, 0x26BE, 0x26F3, 0x26F8, 0x1F3BF, 
    0x1F6F7, 0x1F6F9
  ];

  if (excluded.includes(codePoint)) return false;

  // 2. 檢查 ZWJ 序列 (例如 👩‍🍳)
  if (char.includes('\u200D')) {
    return char.includes('👩') || char.includes('👨') || char.includes('🧑') || 
           char.includes('👦') || char.includes('👧') || char.includes('👶');
  }

  // 3. 檢查基本範圍
  if (codePoint === 0x1F442 || codePoint === 0x1F443) return true; // 耳朵, 鼻子
  if (codePoint >= 0x1F446 && codePoint <= 0x1F450) return true; // 手勢
  if (codePoint >= 0x1F466 && codePoint <= 0x1F478) return true; // 人物
  if (codePoint >= 0x1F481 && codePoint <= 0x1F487) return true;
  if (codePoint === 0x1F4AA) return true; // 二頭肌
  if (codePoint >= 0x1F590 && codePoint <= 0x1F596) return true;
  if (codePoint >= 0x1F645 && codePoint <= 0x1F64F) return true;

  if (codePoint >= 0x1F90F && codePoint <= 0x1F93E) {
    if (codePoint === 0x1F90F) return true;
    if (codePoint >= 0x1F918 && codePoint <= 0x1F91F) return true;
    if (codePoint === 0x1F926) return true;
    if (codePoint >= 0x1F930 && codePoint <= 0x1F93E) return true;
    return false;
  }

  if (codePoint >= 0x1F9B5 && codePoint <= 0x1F9B9) return true;
  if (codePoint >= 0x1F9D1 && codePoint <= 0x1F9DD) return true;
  
  if (codePoint === 0x1F3CB || codePoint === 0x1F3CC || codePoint === 0x1F3C3 || 
      codePoint === 0x1F3C4 || codePoint === 0x1F3CA) return true;

  return false;
};

/**
 * 應用膚色修飾符
 */
export const applySkinTone = (emoji, toneId) => {
  if (!emoji) return '';
  const char = typeof emoji === 'string' ? emoji : emoji.char;
  
  if (toneId === 'default' || !canHaveSkinTone(emoji)) return char;

  const modifier = String.fromCodePoint(parseInt(toneId, 16));

  // 處理 ZWJ 序列 (👩‍🍳 -> 👩🏽‍🍳)
  if (char.includes('\u200D')) {
    return char.split('\u200D').map(part => {
      // 對序列中的人物部分應用膚色
      return canHaveSkinTone({ char: part, category: 'gestures' }) ? part + modifier : part;
    }).join('\u200D');
  }

  return char + modifier;
};

/**
 * 取得 Twemoji 圖像 URL (解決 Windows 國旗顯示問題)
 * @param {string} char - Emoji 字元
 * @returns {string} - SVG 圖片網址
 */
export const getTwemojiUrl = (char) => {
  const code = Array.from(char)
    .map(c => c.codePointAt(0).toString(16))
    .join('-');
  return `https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${code}.svg`;
};